module.exports = __webpack_public_path__ + "img/sympathetic_and_kind.45ebd5c1.svg";